import React, { FC } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import { TIME_24_FORMAT } from 'src/shared/constants';
import { useEditingTimeInput } from 'src/shared/hooks';

interface Props {
  value: string | null;
  onInput: (value: string | undefined) => void;
  error?: string;
  disabled?: boolean;
}

export const EmployeeAvailabilityTimeTextField: FC<Props> = ({ value, onInput, error, disabled }) => {
  const {
    value: timeValue,
    onInputChange,
    onInputBlur,
  } = useEditingTimeInput({ incomingDateTime: value, onBlur: onInput, incomingDateTimeFormat: TIME_24_FORMAT });

  return (
    <Stack direction="column" gap={0.5}>
      <TextField
        sx={(theme) => ({
          input: { padding: '8px', background: theme.palette.mode === 'light' ? 'white' : undefined },
        })}
        error={!!error}
        value={timeValue}
        onChange={onInputChange}
        onBlur={onInputBlur}
        disabled={disabled}
      />
      {!!error && <FormHelperText error>{error}</FormHelperText>}
    </Stack>
  );
};
